__turbopack_context__.v({
  "closeIcon": "index-module__Br_C-a__closeIcon",
  "fileIcon": "index-module__Br_C-a__fileIcon",
  "inner": "index-module__Br_C-a__inner",
  "label": "index-module__Br_C-a__label",
  "progressSection": "index-module__Br_C-a__progressSection",
  "root": "index-module__Br_C-a__root",
});
